// extracted by mini-css-extract-plugin
export default {"searchContainer":"SearchBar_searchContainer__coZXS","searchInput":"SearchBar_searchInput__nCpK1"};